import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MickChat } from "@/components/MickChat";
import { BlockExplorer } from "@/components/BlockExplorer";
import { VideoGallery } from "@/components/VideoGallery";
import { MiningDashboard } from "@/components/MiningDashboard";
import { Footer } from "@/components/Footer";
import { AuthModal } from "@/components/AuthModal";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-aox-bg text-white selection:bg-aox-cyan/30 overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <MickChat />
          <BlockExplorer />
          <VideoGallery />
          <MiningDashboard />
        </main>
        <Footer />
        <AuthModal />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0D18",
              border: "1px solid rgba(0,240,255,0.3)",
              color: "#F8FAFC",
              fontFamily: "Chivo Mono, monospace",
            },
          }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
